import styled from 'styled-components';
interface StyledProps {
    fontSize?: number;
    line?: boolean;
    color?: string;
    fontWeight?: boolean;
}
export const Styled = styled.div<StyledProps>`
    font-weight: ${({ fontWeight }) => (fontWeight ? `bold!important` : 'normal!important')};
    color: ${({ color }) => (color ? `${color}!important` : 'inherit!important')};
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 0.15em;
    position: relative;
    font-family: Arial, Helvetica, sans-serif;

    text-decoration: ${({ line }) => (line ? `line-through!important` : 'none!important')};

    .currency-price {
        & > span {
            font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px!important` : 'inherit!important')};
        }
        display: flex;
        align-items: baseline;
    }
    .other-symbol {
        font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px!important` : 'inherit!important')};
    }
    .tl-text {
        font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px!important` : 'inherit!important')};
        margin-left: 0.15em;
        padding-bottom: 2px;

        &.small {
            font-size: ${({ fontSize }) => (fontSize ? `${fontSize * 0.8}px!important` : 'inherit!important')};
        }
    }
    sub {
        font-size: ${({ fontSize }) => (fontSize ? `${fontSize * 0.8}px!important` : 'inherit!important')};
        vertical-align: baseline;
        line-height: 1;

        display: inline-flex;
        align-items: center;
    }
    .tl-symbol {
        font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px!important` : 'inherit!important')};
    }
`;
